export enum SendRate {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
}
